<div class="d-flex flex-column justify-content-center align-items-center modal-product" style="padding:30px 10px;">
    <form [formGroup]="editForm" (ngSubmit)="onSubmit()"
        class="d-flex flex-column justify-content-center align-items-center w-100">
        <div class="dialog-title">
            <h4>{{ getTitle() }}</h4>
            <button mat-icon-button aria-label="close dialog" mat-dialog-close tabindex="-1"
                style="position:absolute; top:0; right:0;">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <mat-dialog-content class="w-100">
            <input type="hidden" id="id" name="id" formControlName="id">
            <div class="d-flex flex-row p-2">
                <div class="d-flex flex-column justify-content-between w-100 p-2">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label for="name">Nazwa</mat-label>
                        <mat-select formControlName="name">
                            @for (item of getMissingNames(); track item) {
                            <mat-option [value]="item">{{item}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                        <mat-label for="val">Wybierz plik</mat-label>
                        <!--input matInput tabindex="3" type="text" formControlName="val" required -->

                        <input #fileInput hidden="true" type="file" onclick="this.value=null"
                            (change)="fileInputChange($event)" accept=".png,.jpg,.mpeg,.mp4,.mpg" />
                        <button mat-flat-button color="accent" (click)="fileInput.click()">Wybierz plik</button>

                    <mat-dialog-actions class="d-flex flex-row justify-content-between w-100 p-2">
                        <button mat-flat-button color="warn" mat-dialog-close class="w-b">Anuluj</button>
                        <button mat-flat-button color="accent" type="submit" [disabled]="checkDisabled()" class="w-b">{{
                            getSaveText() }}</button>
                    </mat-dialog-actions>

                </div>
            </div>

        </mat-dialog-content>
    </form>
</div>